import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Globalicon from './partials/Globalicon';
import LatestOffer from './LatestOffer';
import Exclusively from './Exclusively';
import About from './partials/About';
import NavbarVideo from './partials/NavbarVideo';
import Amenities from './partials/Amenities';

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>V Hotel The Grand Shoba - Luxury Hotel Near Delhi Airport</title>
        <meta
          name="description"
          content="V Hotel The Grand Shoba offers luxurious stays, world-class dining, and exceptional service near Delhi Airport. Discover our exclusive offers and premium experiences."
        />
        <meta property="og:title" content="V Hotel The Grand Shoba - Luxury Hotel Near Delhi Airport" />
        <meta property="og:description" content="Experience the grandeur of V Hotel The Grand Shoba, a premier luxury hotel near Delhi Airport. Enjoy exceptional dining, corporate events, and exclusive offers." />
        <meta property="og:image" content="images/home/hotel-banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.vhotelthegrandshoba.com/images/contactus/contact-us-header-image.jpg" />
      </Helmet>

      {loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#fff',
          }}
        >
          <video
            src="/videos/logo_1.mp4"
            autoPlay
            muted
            loop
            style={{
              width: '200px',
              height: '200px',
              objectFit: 'contain',
            }}
          />
        </div>
      ) : (
        <>
          <NavbarVideo />
          <About />
          <Globalicon />
          <LatestOffer />
          <Exclusively />
          <Amenities />
        </>
      )}
    </>
  );
}
